// src/locales/LanguageSetter.jsx

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSetter = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // cada cop que canvia l'idioma, actualitza <html lang="...">
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
};

export default LanguageSetter;
